import React, { useState } from 'react';

import classnames from 'classnames';
import { Row, Col, Button, Modal, notification } from 'antd';
import { EditOutlined, DeleteOutlined, StopOutlined } from '@ant-design/icons';

import { WithLoading, dialogFunction } from 'common/components';
import AgGrid from 'common/components/ag-grid/AgGrid';

import { useGetColumnsGrid } from 'hooks/useGetColumns';

import { formatBanListColumns } from './utils';

import * as services from 'services/members';
import * as endpoints from 'services/members/endpoints';

import { useIntl } from 'react-intl';
import Message from 'i18n/messages/member-profile';

import './BanListModal.less';

const BanListModal = (props) => {
  const intl = useIntl();

  const { visible, closeBanList } = props;

  const [gridApi, setGridApi] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [rowsSelected, setRowSelected] = useState([]);

  const { data: columns } = useGetColumnsGrid('get-ban-list-grid', {
    enabled: !!visible,
  });
  const columnDefs = formatBanListColumns(columns);

  const onSetSelectedRows = (selectedNodesDetail) => {
    const bannedMemmberIdList = selectedNodesDetail.map(
      (nodeDetail) => nodeDetail?.bannedMemberId
    );
    setRowSelected(bannedMemmberIdList);
  };

  async function toggleRemoveBanList() {
    if (rowsSelected.length > 0) {
      setIsLoading(true);
      const res = await services.removeToBanList({ memberIds: rowsSelected });
      setIsLoading(false);
      if (res?.isSuccess) {
        notification.success({
          message: 'Remove items from ban list successfully!',
          top: 50,
        });
        refreshGrid();
        setRowSelected([]);
      } else {
        notification.error({
          message: 'Failed to remove items from ban list!',
          top: 50,
        });
      }
    } else {
      notification.error({
        message: 'Should choose item to remove!',
        top: 50,
      });
    }
  }

  function refreshGrid() {
    if (gridApi) gridApi.rivirPurgeServerSideCache();
  }

  const confirmDelete = () => {
    dialogFunction({
      type: 'warn',
      content: intl.formatMessage(Message.deleteItemsFromBanList),
      okText: 'OK',
      cancelText: 'Cancel',
      onOk: toggleRemoveBanList,
    });
  };

  return (
    <Modal
      title='Ban list'
      visible={visible}
      onCancel={() => {
        closeBanList();
        setIsEdit(false);
      }}
      className='ban-list-modal'
      width={'650px'}
      destroyOnClose
    >
      <Row justify='space-between'>
        <Col></Col>
        <Col className='ban-list-modal__header'>
          {!isEdit && (
            <Button
              className={classnames('ban-list-modal__edit-button')}
              // className='agGrid-edit-header__section-btn-edit'
              type='link'
              icon={<EditOutlined />}
              onClick={() => {
                setIsEdit(!isEdit);
              }}
            />
          )}
          {isEdit && (
            <Button
              className={classnames('ban-list-modal__delete-button')}
              disabled={rowsSelected?.length < 1}
              type='danger'
              onClick={() => {
                confirmDelete();
              }}
            >
              <DeleteOutlined />
              Delete
            </Button>
          )}
          {isEdit && (
            <Button
              className={classnames('ban-list-modal__cancel-button')}
              type='default'
              style={{ borderRadius: '4px' }}
              icon={<StopOutlined />}
              onClick={() => setIsEdit(false)}
            >
              Cancel
            </Button>
          )}
        </Col>
      </Row>
      <WithLoading loading={isLoading}>
        <Row style={{ height: 'calc(70vh - 160px)' }}>
          <AgGrid
            columnDefs={columnDefs}
            urlGrid={endpoints.GET_BAN_LIST}
            urlGridDistinct={endpoints.GET_BAN_LIST_DISTINCT}
            responseParams='data'
            getGridApi={(gridApi) => {
              setGridApi(gridApi);
            }}
            onHandleSelectedRowCustom={onSetSelectedRows}
            // requestParams={requestParams}
          />
        </Row>
      </WithLoading>
      <button
        id='ban-list-modal__refresh-button'
        style={{ display: 'none' }}
        onClick={() => refreshGrid()}
      ></button>
      <button
        id='ban-list-modal__close-edit-button'
        style={{ display: 'none' }}
        onClick={() => setIsEdit(false)}
      ></button>
    </Modal>
  );
};

export default BanListModal;
